import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdvancedsearchComponent } from '../../../pages/advancedsearch/advancedsearch.component';
import { AdvancedResourcesComponent } from '../../../components/search/advanced-resources/advanced-resources.component';
import { RefineSearchComponent } from '../../../pages/advancedsearch/refine-search/refine-search.component';
import { AdvancedFiltersComponent } from '../../../pages/advancedsearch/refine-search/advanced-filters/advanced-filters.component';
import { CustomAdvancedFiltersComponent } from '../../../pages/advancedsearch/refine-search/custom-advanced-filters/custom-advanced-filters.component';
import { SharedModule } from '../../../shared/shared.module';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [
    AdvancedsearchComponent,
    AdvancedResourcesComponent,
    RefineSearchComponent,
    AdvancedFiltersComponent,
    CustomAdvancedFiltersComponent,
  ],
  exports: [
    AdvancedsearchComponent,
    AdvancedResourcesComponent,
    RefineSearchComponent,
    AdvancedFiltersComponent,
    CustomAdvancedFiltersComponent,
  ],
})
export class AdvancedSharedModule {}
